import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const toolbarFeatureFlagsLight = "https://res.cloudinary.com/dmukukwp6/video/upload/posthog.com/contents/images/products/product-analytics/toolbar-feature-flags-light-mode.mp4";
export const toolbarFeatureFlagsDark = "https://res.cloudinary.com/dmukukwp6/video/upload/posthog.com/contents/images/products/product-analytics/toolbar-feature-flags-dark-mode.mp4";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ProductVideo = makeShortcode("ProductVideo");
const layoutProps = {
  toolbarFeatureFlagsLight,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`The toolbar enables you to test your feature flags. You can enable, disable, or override your feature flags, and then view how your website or app changes with the new feature flags values.`}</p>
    <p>{`To do this, click on the "Feature Flags" button in the toolbar, search for any feature flag, and click on the toggles to change its value. `}</p>
    <p>{`Overriding feature flags will only affect `}<em parentName="p">{`your`}</em>{` browser. You may also need to refresh the page to see how your change affect your website. It does not affect feature flags evaluation for your backend.`}</p>
    <ProductVideo videoLight={toolbarFeatureFlagsLight} videoDark={toolbarFeatureFlagsDark} alt="How to override feature flags using the toolbar" classes={"rounded"} mdxType="ProductVideo" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      